import { Route } from "react-router-dom"
import { lazy } from "react"

const MyBids = lazy(() => import("../features/my-bids-artisan/components/MyBids"))
const ProjectHubPage = lazy(() => import("../features/artisan-project-hub/ProjectHubPage"))
const ProjectDetailsPage = lazy(() => import("../features/artisan-project-hub/ProjectDetailPage"))
const ArtisanSettings = lazy(() => import("../features/artisan-settings/ArtisanSettingsPage"))
const ArtisanDashboard = lazy(() => import("../features/artisan-dashboard/ArtisanDashboardPage"))
const ArtisanPortfolio = lazy(() => import("../features/artisan-portfolio/components/ArtisanPortfolio"))
const ArtisanProfileDetailsPage = lazy(() => import("../features/artisan-private-profile/ArtisanPrivateProfilePage"))
const ProfileModal = lazy(() => import("../features/artisan-public-profile/ProfileModal"))
const ArtisanBookingsPage = lazy(() => import("../features/artisan-booking-request/components/ArtisanBookingsPage"))

export default function ArtisanRoutes() {
  return (
    <>
      <Route path="/artisan/dashboard" element={<ArtisanDashboard />} />
      <Route path="/artisan/bookings" element={<ArtisanBookingsPage />} />
      <Route path="/artisan/portfolio" element={<ArtisanPortfolio />} />
      <Route path="/artisan/profile" element={<ArtisanProfileDetailsPage />} />
      <Route path="/artisan/settings" element={<ArtisanSettings />} />
      <Route path="/artisan/:userId" element={<ProfileModal />} />
      <Route path="/artisan/my-bids" element={<MyBids />} />
      <Route path="/artisan/project-hub" element={<ProjectHubPage />} />
      <Route path="/artisan/projects/:projectId" element={<ProjectDetailsPage />} />
    </>
  )
}
